import { ChapterId, StepEntry } from "@/types/content-types";
import { createContext, MutableRefObject, useContext } from "react";

export type StepHandlerContextType = {
    currentStep: StepEntry;
    setStepNumber: (stepNumber: number) => void;
    setChapterNumber: (chapterNumber: number) => void;
    chapterRefs: MutableRefObject<Map<ChapterId, HTMLElement>>;
};

const StepHandlerContext = createContext<StepHandlerContextType | undefined>(undefined);
export const StepHandlerContextProvider = StepHandlerContext.Provider;

export function useStepHandler() {
    const ctx = useContext(StepHandlerContext);
    // if (!ctx) throw new Error("useStepHandler must be used within a <StepHandlerProvider />");
    return ctx;
}